/**
 * Virex Sampleshare
 * File: System.js
 * Description: system spec functional component
 * Author: Michal Visnovsky
 * Date: 1.5.2022
 *
 * This code is provided to the community under the two-clause BSD license as
 * follows:
 *
 * Copyright (C) 2023 ESET
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */


import Context from "../../../context";
import React, {useContext, useEffect, useState} from "react";
import Subnav from "./Subnav";

export default function System() {
    const context = useContext(Context)
    const [data, setData] = useState(null);

    // get specs
    const getSystemSpecs = async () => {
        const res = await context.axiosJWT.get(`/api/get_system_specs`, {
            headers: {authorization: "Bearer " + context.user.token}
        }).catch(e => {
        })
        if (res) {
            setData(res.data)
        }
    }

    // on load
    useEffect(async () => {
        await getSystemSpecs()
    }, [])

    return (
        <>
            <Subnav
                params={[
                    {pathname : "/users_external", type: 'external'},
                    {pathname: '/users_internal', type: 'internal'},
                    {pathname: '/system', type: 'system'}
                ]}
            />
            {data ? (
                <div className="login-form">
                    <div className="login-form-wrapper">
                        <div className="input-wrapper">
                            <h1 className='sign-in'>System</h1>
                            <label>
                                System OS: {data.os}
                            </label>
                            <label>
                                DB Version: {data.dbVersion}
                            </label>
                            <label>
                                CPU load: {parseInt(data.cpuLoad)}%
                            </label>
                            <label>
                                Storage: {parseInt(data.storageUsed) / 1024000000} GB/ {parseInt(data.storageSize) / 1024000000} GB
                            </label>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="login-form">
                    <div className="login-form-wrapper">
                        <div className="input-wrapper">
                            <h1 className='sign-in'>System</h1>
                            Loading
                        </div>
                    </div>
                </div>

            )}

        </>
    )
}